import { render, staticRenderFns } from "./ReporteCompra.vue?vue&type=template&id=5b16cf01&"
import script from "./ReporteCompra.vue?vue&type=script&lang=js&"
export * from "./ReporteCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports